import styled from "styled-components";
const fontSize = localStorage.getItem("fontSize");

export const Div = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const Button = styled.button`
  border: 1px solid #101e8e;
  padding: 0.5rem;
  color: #101e8e;
  background: #fff;
  transition: ease-in-out 0.2s;
  cursor: pointer;
  &:hover {
    color: #fff;
    background: #101e8e;
  }
`;

export const NotificationButton = styled.button`
  border: none;
  color: #fff;
  background: #62aa51;
  position: absolute;
  right: 5rem; 
  z-index: 0;
  top: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 60px;
  width: 60px;
  svg {
    color: #fff;
  }
  div {
    background: #101e8e;
    color: #fff;
    position: absolute;
    top: 0.6rem;
    right: 8px;
    border-radius: 50%;
    height: 20px;
    width: 20px;
    font-size: calc(${fontSize} - 4px);
    display: grid;
    place-items: center;
  }
  @media (max-width: 740px) {
    display: none;
  }
`;
